var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
// import { withTranslation } from "react-i18next";
import * as Sentry from '@sentry/browser';
var ErrorBoundaryNaked = /** @class */ (function (_super) {
    __extends(ErrorBoundaryNaked, _super);
    function ErrorBoundaryNaked(props) {
        var _this = _super.call(this, props) || this;
        _this.eventId = props.eventId;
        _this.hasError = props.hasError;
        return _this;
    }
    // static getDerivedStateFromError(error: any) {
    //   return this.hasError;
    // }
    ErrorBoundaryNaked.prototype.componentDidCatch = function (error, errorInfo) {
        var _this = this;
        Sentry.withScope(function (scope) {
            scope.setExtras(errorInfo);
            var eventId = Sentry.captureException(error);
            _this.setState({ eventId: eventId });
        });
    };
    ErrorBoundaryNaked.prototype.render = function () {
        var _this = this;
        if (this.hasError) {
            return (React.createElement("button", { onClick: function () { return Sentry.showReportDialog({ eventId: _this.eventId }); } }, this.t('report-error')));
        }
        //when there's not an error, render children untouched
        return this.props.children;
    };
    return ErrorBoundaryNaked;
}(Component));
export var ErrorBoundary = ErrorBoundaryNaked;
